module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "action": "/search",
      "method": "get",
      "role": "search"
    }
  }, [_c('label', {
    staticClass: "label-hidden",
    attrs: {
      "for": "Search"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.i18n.placeholder) + "\n\t")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "search",
      "name": "q",
      "id": "Search",
      "placeholder": _vm.i18n.placeholder
    },
    domProps: {
      "value": _vm.search_terms
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "icon-fallback-text"
  }, [_vm._v(_vm._s(_vm.i18n.submit))])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "role": "navigation"
    }
  }, [_c('ul', {
    staticClass: "site-nav"
  }, _vm._l((_vm.linklists), function(link) {
    return _c('li', {
      class: {
        'site-nav--active': link.active
      }
    }, [_c('a', {
      staticClass: "site-nav__link",
      attrs: {
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))])])
  }))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-497015c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497015c0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 56
// module chunks = 0